import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../BaseUrl";


export const ExamFormDetailsPostAPI = createAsyncThunk("ExamFormDetailsPost", async ({ data }) => {
    const {
        M_MainSubjectID,
        M_SubSubjectID,
        OptionalSub_M_IndicatorID,
        FullName,
        Age,
        ContactNumber,
        Email,
        Category_M_IndicatorID,
        Week_Category_M_IndicatorID,
        Name_Of_Organization,
        ExaminationPurpose,
        PaidExamFee,
        UploadReceipt,
        UploadReceiptExtension,
        handleIsPost
    } = data


    var formdata = new FormData();
    formdata.append("M_MainSubjectID", M_MainSubjectID);
    formdata.append("M_SubSubjectID", M_SubSubjectID);
    formdata.append("OptionalSub_M_IndicatorID", OptionalSub_M_IndicatorID);
    formdata.append("FullName", FullName);
    formdata.append("Age", Age);
    formdata.append("ContactNumber", ContactNumber);
    formdata.append("Email", Email);
    formdata.append("Category_M_IndicatorID", Category_M_IndicatorID);
    formdata.append("Week_Category_M_IndicatorID", Week_Category_M_IndicatorID);
    formdata.append("Name_Of_Organization", Name_Of_Organization);
    formdata.append("ExaminationPurpose", ExaminationPurpose);
    formdata.append("PaidExamFee", PaidExamFee);
    formdata.append("UploadReceipt", UploadReceipt);
    formdata.append("UploadReceiptExtension", UploadReceiptExtension);


    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Transaction/POST_T_ExaminationForm_Insert`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                // toastSuccess(result.message)
                handleIsPost()
            } else {
                // toastError(result.message)
            }
            return result
        })
})


const ExamFormDetailsPostSlice = createSlice({
    name: "ExamFormDetailsPost",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ExamFormDetailsPostAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ExamFormDetailsPostAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(ExamFormDetailsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
});
export const ExamFormDetailsPostReducer = ExamFormDetailsPostSlice.reducer;
